import { SafeArea } from "capacitor-plugin-safe-area";
import { platform } from "../config";

const directions = ["top", "left", "right", "bottom"] as const;

export function defineSafeAreaInsets() {
  if (platform === "android") {
    SafeArea.getSafeAreaInsets().then(({ insets }) => {
      for (const direction of directions) {
        document.body.style.setProperty(
          `--safe-area-inset-${direction}`,
          `${insets[direction]}px`,
        );
      }
    });
  } else {
    for (const direction of directions) {
      document.body.style.setProperty(
        `--safe-area-inset-${direction}`,
        `env(safe-area-inset-${direction}, 0)`,
      );
    }
  }
}
